export default {
  'user.login': 'Accesso',
  'user.signup': 'Scriviti',
  'user.profile': 'Profilo',
  'user.reset_password': 'Resetta la password',
  'user.user_management': 'Gestione utenti',
  'user.send_verification_sms': 'Invia SMS di verifica',
  'user.verification_check': 'Controllo di verifica',
  'user.change_password': 'Cambia la password',
  'user.username_email': 'Nome utente / Email',
  'user.email': 'Email',
  'user.phone': 'Cellulare senza zero',
  'user.password': 'Password',
  'user.forgetpassword': 'Hai dimenticato la password ?',
  'user.loginwithgoogle': 'Accedi via google',
  'user.changepass': 'La tua password è cambiata correttamente!',
  'user.createaccount': 'Creare un profilo',
  'user.offerservices': 'Offriamo tutti i servizi del viaggio',
  'user.welcome': 'Benvenuti a Tripsi',
  'user.firstname': 'Nome',
  'user.lastname': 'Cognome',
  'user.agreemessage': "Sono d'accordo con",
  'user.rotapolicy': 'Accetto le regole di Tripsi',
  'user.rotapolicy_tripord': 'Accetto le regole di Tripord',
  'user.rotacopyright': "Diritto d'autore 2018 © di Tripsi",
  'user.emptypass': 'Per favore inserisci la vecchia o nuova password',
  'user.oldpass': 'La vecchia password non corrisponde!',
  'user.employeeadd': 'Dipendente aggiunto correttamente',
  'user.tryagain': 'Per favore riprova',
  'user.changepasssuccess': 'La tua password non è stata cambiata',
  'user.newpass': 'Per favore inserisci una nuova password',
  'user.loginerror': 'Nome utente o password non sono corretti',
  'user.userlock': 'Il nome utente è bloccato',
  'user.changepasserror':
    ' La nuova password e  nuova password reinserita non corrispondono',
  'user.tripsi': 'Tripsi',
  'user.tripord': 'Tripord',
  'user.userpoint': 'Punto utente',
  'user.duplicatedusername': "L'email è duplicata",
  'user.signuperror': "L'email deve essere unica",
  'user.forgetyour': 'Dimenticare',
  'user.createyour': 'crea il tuo',
  'user.account': 'account',
  'user.registerwith': 'o registrati con',
  'user.acceptrules': 'Accetta le regole del sito',
  'user.fillallfield': 'riempi tutti i campi',
  'user.favourites': 'Preferite',
  'user.nograde': 'Nessun voto',
  'user.phone': 'Telefono',
  'user.has_account': 'Ho un account Tripsi',
  'user.has_account_tripord': 'Ho un account Tripord',
  'user.donthaveaccount': 'Non ti sei registrato prima?',
  'user.signup_free': 'Iscriviti gratis',
  'user.pass_recovery': 'Recupero della password',
  'user.remember_password': 'Ricordi la tua password?',
  'authentication.slugone':
    'Il fornitore più affidabile di servizi turistici in Iran',
  'user.otplogin': 'Accedi inviando un codice tramite SMS',
  'user.otplogintitle': 'Password una tantum',
  'user.incorrectcode': 'Il codice inserito non è corretto',
  'user.untilresend': 'Fino a rispedire',
  'user.phoneoremail': 'E-mail o cellulare',
  'user.loginwithusername': 'Accedi con nome utente',
  'user.sendcode': 'Manda il codice',
  'user.sendagain': 'Invia di nuovo',
  'user.justwelcome': 'Login',
};
